import type { Uid } from '../types/common.ts';

export function uidsWellKnown(env: 'test' | 'prod') {
  return env === 'test'
    ? {
        tylerChurch: '57qA6cNRmYhwvQBTjEhfQPL5PJw1' as Uid,
        brandonCurtis: 'sCs9fqwp6HguvJ7gJ1s9LBzZmzg1' as Uid,
        developerAccount: 'opgrG1hbtqUbEjCnBoimevZM8uq1' as Uid,
      }
    : {
        tylerChurch: '4ivOOWkdxhVIaj3rySha7fe9Icw1' as Uid,
        brandonCurtis: 'xxMJ43HSNEYlrwSIcRcr7uqFMCu2' as Uid,
        developerAccount: 'DX6A99f07Re8jJsTLJ7Omi1eRND3' as Uid,
      };
}
